<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <IFormField>
      <label iLabel>{{ t("common.name") }}</label>
      <input
        iInput
        size="sm"
        [placeholder]="t('product-group-creation.give_product_group_name')"
        [(ngModel)]="pgName"
        [maxLength]="80"
      />
    </IFormField>

    <div class="flex justify-end gap-x-2 pt-4">
      <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button iButton (click)="create()">{{ t("common.next") }}</button>
    </div>
  </div>
</ng-container>
